import { jsx } from "react/jsx-runtime";
import React__default from "react";
import Skeleton__default from "antd/es/skeleton";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import { getMapComponent } from "./implementations/index.js";
import { MAP_CLUSTER, MAP_PLACEMARK } from "./Map.constants.js";
import './Map.css';/* empty css         */
const MapSkeleton = () => {
  return /* @__PURE__ */ jsx(Skeleton__default.Node, { active: true, className: classnames("perxis-auto-map__skeleton"), children: /* @__PURE__ */ jsx(Typography.Title, { headingLevel: 5, level: "h1", color: "dark-light", children: /* @__PURE__ */ jsx(Icon, { name: "geo" }) }) });
};
const Map = ({
  mapsKey,
  language,
  region,
  mapsProvider,
  pins,
  selected,
  hovered,
  className,
  styles,
  onSelectPin,
  onHoverPin,
  onMapClick,
  occupiedAreas,
  shouldZoomOnClickPin = false,
  scrollZoom = false,
  multiTouch = true,
  minZoom,
  maxZoom,
  enableBalloon = false,
  enableHint = false,
  enableClustering = false,
  balloonContent,
  hintContent,
  placemarkImage = MAP_PLACEMARK.default,
  placemarkActiveImage = MAP_PLACEMARK.active,
  placemarkHoverImage = MAP_PLACEMARK.hover,
  placemarkSize,
  placemarkHoverSize,
  placemarkActiveSize,
  placemarkOffset,
  placemarkHoverOffset,
  placemarkActiveOffset,
  clusterImage = MAP_CLUSTER.default,
  clusterHoverImage = MAP_CLUSTER.hover,
  clusterSize,
  clusterHoverSize,
  // TODO: Разобраться нужны ли параметры offset для кластеров (сейчас offset используются лишь для ymap)
  clusterOffset,
  clusterHoverOffset,
  fullscreenControl,
  onPressFullscreen
}) => {
  const MapComponent = getMapComponent(mapsProvider);
  if (!MapComponent) {
    console.warn("Не найден компонент для провайдера!", mapsProvider);
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-map", className), children: /* @__PURE__ */ jsx(React__default.Suspense, { fallback: /* @__PURE__ */ jsx(MapSkeleton, {}), children: /* @__PURE__ */ jsx(
    MapComponent,
    {
      mapsKey,
      language,
      region,
      pins,
      selected,
      hovered,
      styles,
      scrollZoom,
      minZoom,
      maxZoom,
      fullscreenControl,
      placemarkImage,
      placemarkActiveImage,
      placemarkHoverImage,
      placemarkSize,
      placemarkHoverSize,
      placemarkActiveSize,
      placemarkOffset,
      placemarkHoverOffset,
      placemarkActiveOffset,
      enableClustering,
      clusterImage,
      clusterHoverImage,
      clusterSize,
      clusterHoverSize,
      clusterOffset,
      clusterHoverOffset,
      shouldZoomOnClickPin,
      enableBalloon,
      enableHint,
      balloonContent,
      hintContent,
      occupiedAreas,
      multiTouch,
      onSelectPin,
      onHoverPin,
      onMapClick,
      onPressFullscreen
    }
  ) }) });
};
export {
  Map as default
};
//# sourceMappingURL=Map.js.map
